import * as apiGetMatchProduct from 'api/match/GetMatchProductNew';
import { ValueScope } from 'enums/valueScope';
import { getNumberString } from 'functions/numberToString';
import { CalculatedNutrient } from 'types/NutrientValue/CalculatedNutrientValues';
import * as NutrientValue from 'types/Recipe/Detail/Erp/Nutrient';
import * as NutrientValueList from 'types/Recipe/Detail/Erp/NutrientList';

export type Type = {
	id: string;
	category: string[];
	externalId: string;
	brand: string;
	price: number;
	imageUrl: string;
	externalUrl: string;
	name: string;
	servingSizeQuantityGram: number;
	nutrientValuesPer100g: NutrientValueList.Type;
	nutrientValuesPerServing: NutrientValueList.Type;
};

export function create(): Type {
	return {
		id: '',
		category: [],
		externalId: '',
		brand: '',
		price: 0,
		imageUrl: '',
		externalUrl: '',
		name: '',
		servingSizeQuantityGram: 100,
		nutrientValuesPer100g: [],
		nutrientValuesPerServing: [],
	};
}

export function mapFromApi(input: apiGetMatchProduct.Product, source: string): Type {
	return {
		id: input.productId,
		category: [input.category],
		externalId: input.externalId,
		brand: source,
		price: input.price ?? 0,
		imageUrl: input.imageUrl ?? '',
		externalUrl: input.externalUrl,
		name: input.name,
		servingSizeQuantityGram: 0,
		nutrientValuesPer100g: [],
		nutrientValuesPerServing: [],
	};
}

export function toString(obj: Type) {
	if (!obj.brand) return obj.name;
	return `${obj.name} (${obj.brand})`;
}

export function getValue(
	nutrient: CalculatedNutrient,
	servingSizeQuantityGram: number,
	product: Type | null,
	valueScope: ValueScope
): number | null {
	if (!product || !nutrient.id)
		return calculateNutrientValue(nutrient, servingSizeQuantityGram, valueScope);
	const nutrientValue: NutrientValue.Type | undefined = NutrientValueList.getById(
		valueScope === ValueScope.Parts
			? product.nutrientValuesPerServing
			: product.nutrientValuesPer100g,
		nutrient.id
	);
	if (!nutrientValue) return null;
	return nutrientValue.total;
}
//
export function calculateNutrientValue(
	nutrient: CalculatedNutrient,
	servingSizeQuantityGram: number,
	valueScope: ValueScope
) {
	if (valueScope === ValueScope.HundredGrams) return nutrient.value;
	return nutrient.value * (servingSizeQuantityGram / 100);
}

export function getValueString(
	nutrient: CalculatedNutrient,
	servingSizeQuantityGram: number,
	product: Type | null,
	cultureCode: string,
	valueScope: ValueScope
): string {
	const result = getValue(nutrient, servingSizeQuantityGram, product, valueScope);
	if (result === null) return '–';
	if (result === undefined) return '–';
	return getNumberString(Math.round(result), cultureCode);
}

export function getSource(nutrient: CalculatedNutrient, productId: string | null): string {
	if (!productId) return nutrient.source ?? 'USDA';
	return 'Sysco';
}
